var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "border-1 rounded-xl shadow-md h-full flex flex-col-reverse py-10 md:py-0",
    class: {
      'md:grid md:grid-cols-12': _vm.position > 1,
      'bg-white': _vm.position < 3,
      'md:col-span-2': _vm.position === 2,
      'bg-white md:bg-indigo-200 md:col-span-1 md:row-span-2': _vm.position === 3
    }
  }, [_c('div', {
    staticClass: "relative flex flex-col items-center mt-10",
    class: {
      'col-span-full md:self-center': _vm.position !== 2,
      'md:mt-0 md:pb-0': _vm.position > 1,
      'md:my-10 md:space-y-5': _vm.position === 1,
      'col-span-7 md:self-end': _vm.position === 2,
      'md:space-y-0 xl:space-y-5': _vm.position === 3
    }
  }, [_vm.position > 1 ? _c('illustration', {
    staticClass: "hidden md:block",
    class: {
      'absolute left-0 bottom-3 md:bottom-18 xl:bottom-32 lg:left-10 xl:left-3 xxl:left-14 2xl:left-28': _vm.canAddBeneficiary && _vm.position === 2,
      'md:transform md:scale-80 lg:scale-85 xl:scale-100 xxl:scale-110 2xl:scale-x-125': _vm.position === 2,
      'md:transform md:scale-75 xl:scale-85 xxl:scale-95 2xl:scale-x-100': _vm.position === 3
    },
    attrs: {
      "name": "Group189"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'mb-10': _vm.position === 2
    }
  }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE) ? _c('action-button', {
    staticClass: "z-10",
    attrs: {
      "id": "add-neopass",
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "AJOUTER UN CARNET",
      "uppercase": true,
      "icon": "plus-circle",
      "right": true,
      "responsive": false,
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.displayAddNeopassPopup
    }
  }) : _vm.isBeneficiary ? _c('router-link', {
    staticClass: "z-10",
    attrs: {
      "to": '/form/neopass/' + _vm.user.id
    }
  }, [_c('action-button', {
    staticClass: "text-2sm",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "bg-color-square": "bg-pink-600",
      "icon-color": "text-white",
      "libelle": "EDITER MON CARNET",
      "uppercase": true,
      "icon": "arrow-right_1",
      "right": true,
      "responsive": false,
      "type-shadow": "shadow-pink",
      "enable-action": false
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "bg-white flex flex-col space-y-4",
    class: {
      'col-span-full w-full justify-start h-full md:mt-5': _vm.position === 1,
      'col-span-5 self-center w-full md:pr-5': _vm.position === 2,
      'col-span-full md:py-5 md:m-2 md:rounded-xl md:shadow-lg': _vm.position === 3,
      'md:px-5': _vm.position !== 2
    }
  }, [_c('div', {
    staticClass: "text-2xl md:text-xl xl:text-2xl font-normal w-full text-center md:text-left",
    attrs: {
      "id": "neopass-list"
    }
  }, [_vm._v("\n      Carnet" + _vm._s(_vm.isBeneficiary ? '' : 's') + "\n      de parcours\n    ")]), _vm._v(" "), _vm.isBeneficiary ? _c('div', {
    staticClass: "overflow-y-auto hide-scroll-bar h-60 md:h-40 xl:h-56"
  }, _vm._l(_vm.listModules.filter(function (m) {
    return _vm.permissions.includes(m.name + '_read') || _vm.permissions.includes(m.name + '_edit');
  }), function (mod, i) {
    return _c('div', {
      key: i,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50 grid grid-cols-12 gap-2 items-center p-4 md:py-2.5 md:px-2.5 xl:p-3"
    }, [_c('div', {
      staticClass: "text-base-0 text-gray-600 font-normal col-span-10 w-full"
    }, [_vm._v("\n          " + _vm._s(mod.display_name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2",
      attrs: {
        "title": "Editer ce module"
      }
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_FORM_PAGE) ? _c('router-link', {
      staticClass: "text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center",
      attrs: {
        "to": '/form/neopass/' + _vm.user.id + '/' + mod.name
      }
    }, [_c('icon', {
      staticClass: "md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600",
      attrs: {
        "name": "edit",
        "label": 'Editer le module ' + mod.display_name
      }
    })], 1) : _c('span', {
      staticClass: "text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center"
    }, [_c('icon', {
      staticClass: "md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600",
      attrs: {
        "name": "edit",
        "label": 'Editer le module ' + mod.display_name
      }
    })], 1)], 1)]);
  }), 0) : _c('div', [_vm.listNeopass != null && _vm.listNeopass.length > 0 ? _c('div', {
    staticClass: "overflow-y-auto hide-scroll-bar",
    class: {
      'h-60 md:h-40 xl:h-56': _vm.position > 1,
      'h-60 md:h-20 xl:h-40': _vm.position === 1 && _vm.buttonDisplayed
    },
    attrs: {
      "id": "neopass-list-dashboard"
    }
  }, _vm._l(_vm.listNeopass, function (neopass, i) {
    return _c('div', {
      key: i,
      staticClass: "odd:bg-indigo-100 odd:bg-opacity-50 grid grid-cols-12 gap-2 items-center p-4 md:p-2.5 xl:p-3",
      attrs: {
        "id": 'neopass-' + i
      }
    }, [_c('div', {
      staticClass: "w-full col-span-3 md:col-span-2 xl:col-span-3"
    }, [_c('div', {
      staticClass: "flex items-center justify-start"
    }, [_c('profile-picture', {
      staticClass: "md:hidden xl:block",
      attrs: {
        "size": "max-w-8 w-8 h-8",
        "other-object": neopass
      }
    }), _vm._v(" "), _c('profile-picture', {
      staticClass: "hidden md:block xl:hidden",
      attrs: {
        "size": "max-w-6 w-6 h-6",
        "other-object": neopass
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "text-gray-600 font-normal text-base-0 col-span-7 md:col-span-8 xl:col-span-7"
    }, [_vm._v("\n            " + _vm._s(neopass.firstname) + "\n            "), _c('span', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(neopass.lastname))])]), _vm._v(" "), _c('div', {
      staticClass: "col-span-2",
      attrs: {
        "title": "Modifier le carnet"
      }
    }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_FORM_PAGE) ? _c('router-link', {
      staticClass: "text-indigo-600 rounded-full bg-pink-100 p-1 h-8 w-8 md:h-6 md:w-6 xl:w-8 xl:h-8 flex justify-center items-center",
      attrs: {
        "to": '/form/neopass/' + neopass.id
      }
    }, [_c('icon', {
      staticClass: "md:h-2 md:w-2 xl:w-3 xl:h-3 text-indigo-600",
      attrs: {
        "name": "edit",
        "label": "Modifier le carnet"
      }
    })], 1) : _c('span', {
      staticClass: "text-indigo-600 rounded-full bg-pink-100 w-8 h-8 flex justify-center items-center"
    }, [_c('icon', {
      staticClass: "md:h-2 md:w-2 xl:w-3 xl:h-3 text-gray-600",
      attrs: {
        "name": "edit",
        "label": "Modifier le carnet"
      }
    })], 1)], 1)]);
  }), 0) : _c('div', {
    staticClass: "text-gray-600 text-center flex items-center justify-center h-60 md:h-40 xl:h-56",
    class: {
      'animate-pulse': _vm.listNeopass == null
    }
  }, [_vm._v("\n        " + _vm._s(_vm.listNeopass == null ? 'En cours de chargement...' : "Vous n'avez pas de carnet de parcours attribué") + "\n      ")])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }